import React, { Component } from "react";
import { Row, Col } from "shards-react";
import { Table, Input, Button, Space, Radio } from "antd";
import Highlighter from "react-highlight-words";
import { SearchOutlined } from "@ant-design/icons";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import feedbackService from "../../../../api/Feedback/FeedbackService";
export default class PreviewAllFeedbacks extends Component {
  constructor(props) {
    super(props);

    this.state = { feedbackList: [] };

    this.handleEvent = this.handleEvent.bind(this);
  }

  componentDidMount() {
    this.getFeedbackList();
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevState.name !== this.state.name) {
      this.handler();
    }
  }

  getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={(node) => {
            this.searchInput = node;
          }}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() =>
            this.handleSearch(selectedKeys, confirm, dataIndex)
          }
          style={{ width: 188, marginBottom: 8, display: "block" }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            Search
          </Button>
          <Button
            onClick={() => this.handleReset(clearFilters)}
            size="small"
            style={{ width: 90 }}
          >
            Reset
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        ? record[dataIndex]
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase())
        : "",
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => this.searchInput.select(), 100);
      }
    },
    render: (text) =>
      this.state.searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
          searchWords={[this.state.searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      ),
  });

  handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    this.setState({
      searchText: selectedKeys[0],
      searchedColumn: dataIndex,
    });
  };

  handleReset = (clearFilters) => {
    clearFilters();
    this.setState({ searchText: "" });
  };

  componentWillUnmount() {}

  // Prototype methods, Bind in Constructor (ES2015)
  handleEvent() {}

  // Class Properties (Stage 3 Proposal)
  handler = () => {
    this.setState();
  };

  getFeedbackList = () => {
    let feedbackList = this.state.feedbackList;
    feedbackService
      .getAllFeedbacks()
      .then((res) => {
        feedbackList = res.data;
        this.setState({ feedbackList });
      })
      .catch((err) => {
        toast.error(err.message, {
          position: toast.POSITION.TOP_CENTER,
        });
      });
  };
  onButtonClick = (id) => {
    feedbackService.deleteFeedback(id);
    toast.success(`Feedback Deleted Successfully`, {
      position: toast.POSITION.TOP_CENTER,
    });
    this.getFeedbackList();
  };

  render() {
    let data =
      this.state.feedbackList != null
        ? this.state.feedbackList
            .sort((a, b) => a.createdAt > b.createdAt)
            .map((feedback, i) => {
              return {
                index: i + 1,
                subject: feedback.subject,
                reason: feedback.reason_category,
                employee_name: feedback.employee_name,
                employee_number: feedback.employee_number,
                message: feedback.message,
                action: (
                  <Button
                    className="btn btn-danger text-white"
                    onClick={() => this.onButtonClick(feedback.id)}
                  >
                    Delete
                  </Button>
                ),
              };
            })
        : null;

    const columns = [
      {
        title: "#",
        dataIndex: "index",
        key: "index",
      },
      {
        title: "Subject",
        dataIndex: "subject",
        key: "subject",
        ...this.getColumnSearchProps("subject"),
      },
      {
        title: "Reason",
        dataIndex: "reason",
        key: "reason",
        ...this.getColumnSearchProps("reason"),
      },
      {
        title: "Employee Name",
        dataIndex: "employee_name",
        key: "employee_name",
        ...this.getColumnSearchProps("employee_name"),
      },
      {
        title: "Employee Number",
        dataIndex: "employee_number",
        key: "employee_number",
        ...this.getColumnSearchProps("employee_number"),
      },
      {
        title: "Message",
        dataIndex: "message",
        key: "message",
        ...this.getColumnSearchProps("message"),
      },
      {
        title: "Action",
        dataIndex: "action",
        key: "action",
      },
    ];
    return (
      <>
        <h5 className="m-0">Feedbacks</h5>
        <Row form>
          <Col md="12" className="form-group  mt-4">
            <Table
              columns={columns}
              dataSource={data !== null ? data : null}
              className="p-0 m-0"
              pagination={{ pageSize: 5, position: ["bottomCenter"] }}
              style={{ textAlign: "center" }}
            />
          </Col>
        </Row>
      </>
    );
  }
}
